/**
 * Created by Radoslaw on 2014-12-11.
 */

import { IMeasurement, FPS_MEASUREMENT_LOGGER } from "./IMeasurements";
import { FpsMeasurementResults } from "./FpsMeasurementResults";
import { getLogger } from "@goodgamestudios/logger";

import Shape = createjs.Shape;
import Event = createjs.Event;

export class FpsMeasurement implements IMeasurement {
    private _counterAsShape: Shape;
    private _samplingTime: number;
    private _framesNumber: number;
    private _fps: number;
    private _samples: any[];
    private _samplesSum: number;

    private logger = getLogger(FPS_MEASUREMENT_LOGGER);

    constructor() {
        this._counterAsShape = new Shape();
        this._samples = [];
    }

    public start(payload: Object = null): void {
        this.cleanupSamples();
        this._samplingTime = Date.now();
        this._framesNumber = 0;
        this._counterAsShape.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.measure));
        this.logger.debug("Executing old method, result not guaranteed");
    }

    public stop(payload: Object = null): void {
        this._counterAsShape.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.measure));
        this.logger.debug("Executing old method, result not guaranteed");
    }

    public dispose(): void {
        if (this._counterAsShape) {
            this._counterAsShape.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.measure));
            this._counterAsShape = null;
        }
        this.logger.debug("Executing old method, result not guaranteed");
    }

    public get results(): FpsMeasurementResults {
        let results: FpsMeasurementResults = new FpsMeasurementResults();
        results.minFps = Math.min.apply(null, this._samples);
        results.maxFps = Math.max.apply(null, this._samples);
        results.averageFps = (results.minFps + results.maxFps) * .5;

        this.logger.debug("Executing old method, result not guaranteed");

        return results;
    }

    private cleanupSamples(): void {
        while (this._samples.length > 0) {
            this._samples.shift();
        }
        this.logger.debug("Executing old method, result not guaranteed");
    }

    private measure(event: Event): void {
        let currentTime: number = Date.now() - this._samplingTime;
        this._framesNumber++;

        if (currentTime > 1000) {
            this._fps = (this._framesNumber * 1000) / currentTime;
            this._samples.push(this._fps);
            this._samplingTime = Date.now();
            this._framesNumber = 0;
            this._samplesSum += this._fps;
        }
        this.logger.debug("Executing old method, result not guaranteed");
    }
}
